/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationsUnsupportedMediaTypeError
 */
export interface NotificationsUnsupportedMediaTypeError {
    /**
     * 
     * @type {number}
     * @memberof NotificationsUnsupportedMediaTypeError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationsUnsupportedMediaTypeError
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsUnsupportedMediaTypeError
     */
    message: string;
}

/**
 * Check if a given object implements the NotificationsUnsupportedMediaTypeError interface.
 */
export function instanceOfNotificationsUnsupportedMediaTypeError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function NotificationsUnsupportedMediaTypeErrorFromJSON(json: any): NotificationsUnsupportedMediaTypeError {
    return NotificationsUnsupportedMediaTypeErrorFromJSONTyped(json, false);
}

export function NotificationsUnsupportedMediaTypeErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsUnsupportedMediaTypeError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'title': json['title'],
        'message': json['message'],
    };
}

export function NotificationsUnsupportedMediaTypeErrorToJSON(value?: NotificationsUnsupportedMediaTypeError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'title': value.title,
        'message': value.message,
    };
}

